export const normalizeString = (str: string): string => {
    return str.trim().replace(' ', '').toLowerCase();
};

export const isEmptyString = (str: string): boolean => {
    return !`${str}`.replace(/\s/g, '').length;
};
